import { render, staticRenderFns } from "./role_list.vue?vue&type=template&id=b24c6b56&scoped=true"
import script from "./role_list.vue?vue&type=script&lang=js"
export * from "./role_list.vue?vue&type=script&lang=js"
import style0 from "./role_list.vue?vue&type=style&index=0&id=b24c6b56&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b24c6b56",
  null
  
)

export default component.exports